// extracted by mini-css-extract-plugin
export default {"container":"Y1yZ6","retryButton":"FnhMT","title":"UgGOW","retryIcon":"cfxbx","retryTitle":"MGLoS","retrySVGPath":"oiAg2","spacer":"JCB6k"};